import { render } from "./coordinate.vue?vue&type=template&id=57c88c02"
import script from "./coordinate.vue?vue&type=script&lang=js"
export * from "./coordinate.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/divform/coordinate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57c88c02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57c88c02', __exports__)) {
    console.log('reload')
    api.reload('57c88c02', __exports__)
  }
  
  module.hot.accept("./coordinate.vue?vue&type=template&id=57c88c02", () => {
    console.log('re-render')
    api.rerender('57c88c02', render)
  })

}


export default __exports__